export function normalizeExternalUrl(url) {
  if (url == null) return url;
  const text = String(url).trim();
  if (!text) return text;
  if (/^https?:\/\//i.test(text)) return text;
  if (text.startsWith("//")) return `https:${text}`;
  return `https://${text}`;
}

const YOUTUBE_EMBED_PARAMS = {
  autoplay: "1",
  controls: "0",
  disablekb: "1",
  fs: "0",
  iv_load_policy: "3",
  modestbranding: "1",
  playsinline: "1",
  rel: "0",
};

function youtubeVideoId(raw) {
  let text = String(raw).trim();
  const iframeSrc = text.match(/src=["']([^"']+)["']/i);
  if (iframeSrc) text = iframeSrc[1];
  text = normalizeExternalUrl(text);
  try {
    const url = new URL(text);
    const host = url.hostname.replace(/^www\./i, "").toLowerCase();
    if (host === "youtu.be") {
      return url.pathname.split("/").filter(Boolean)[0] || null;
    }
    if (!host.endsWith("youtube.com") && !host.endsWith("youtube-nocookie.com")) {
      return null;
    }
    const fromQuery = url.searchParams.get("v");
    if (fromQuery) return fromQuery;
    const parts = url.pathname.split("/").filter(Boolean);
    if (["embed", "live", "shorts", "v", "e"].includes(parts[0]) && parts[1]) {
      return parts[1];
    }
  } catch {
    return null;
  }
  return null;
}

function withSearchParams(href, extra) {
  const url = new URL(href);
  Object.entries(extra).forEach(([key, value]) => {
    url.searchParams.set(key, String(value));
  });
  return url.toString();
}

export function toYouTubeEmbedSrc(raw, extra = YOUTUBE_EMBED_PARAMS) {
  if (raw == null) return "";
  const text = String(raw).trim();
  if (!text) return "";
  const videoId = youtubeVideoId(text);
  if (videoId) {
    return withSearchParams(`https://www.youtube.com/embed/${videoId}`, extra);
  }
  try {
    return withSearchParams(normalizeExternalUrl(text), extra);
  } catch {
    return text;
  }
}
